import { V2Button } from '@abyss/web/ui/Button';
import { Layout } from '@abyss/web/ui/Layout';
import { V2ModalDialog } from '@abyss/web/ui/ModalDialog';
import { find } from 'lodash';
import { useTranslation } from 'react-i18next';

import { ClientNames, Constants } from './../../../common/Constants';
import { ConstantsLagoon } from '../../../common/ConstantsLagoon';
import { useLagoon } from '../../../hooks/useLagoon';

export const WARNING_MINUTES = 5;

type Props = {
  handleClose: () => void;
  handleLogin: () => void;
};

export const GuestTimeoutModalWarning = ({
  handleClose,
  handleLogin,
}: Props) => {
  const { t } = useTranslation();
  const clientName = sessionStorage.getItem(
    Constants.STORAGE_KEYS.SESSION.CLIENT_NAME
  );
  const isGehaOrUmrGuest =
    clientName?.toLowerCase() === ClientNames.GEHA ||
    clientName?.toUpperCase() === ClientNames.UMR;

  const data = useLagoon('ui-messaging')();

  const guestTimeoutWarningModalBodyText = find(data, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION.GUEST_TIMEOUT_WARNING_MODAL_BODY,
  })?.message;

  const gehaGuestTimeoutWarningModalBodyText = find(data, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION
      .GEHA_GUEST_TIMEOUT_WARNING_MODAL_BODY,
  })?.message;

  return (
    <V2ModalDialog
      closeOnClickOutside={false}
      css={{
        'abyss-modal-base-header-container': {
          padding: '16px',
        },
      }}
      data-auto-testid="guest-timeout-modal-warning"
      data-testid="guest-timeout-modal-warning"
      footer={
        <Layout.Group alignLayout="right" style={{ gap: 8 }}>
          <V2Button
            data-auto-testid="timeout-modal-warning-stay-in-session"
            data-testid="timeout-modal-warning-stay-in-session"
            onClick={handleClose}
          >
            {t('INACTIVITY_MODAL.STAY_IN_SESSION')}
          </V2Button>
          {!isGehaOrUmrGuest && (
            <V2Button
              data-auto-testid="timeout-modal-warning-sign-in"
              data-testid="timeout-modal-warning-sign-in"
              onClick={handleLogin}
              variant="outline"
            >
              {t('INACTIVITY_MODAL.SIGN_IN')}
            </V2Button>
          )}
        </Layout.Group>
      }
      header={t('INACTIVITY_MODAL.TITLE_END_IN', { minutes: WARNING_MINUTES })}
      isOpen
      onClose={handleClose}
    >
      {isGehaOrUmrGuest
        ? gehaGuestTimeoutWarningModalBodyText
        : guestTimeoutWarningModalBodyText}
    </V2ModalDialog>
  );
};
